let dragDropTouchLoadPromise;

const DRAG_DROP_TOUCH_SRC =
  'https://bernardo-castilho.github.io/DragDropTouch/DragDropTouch.js';

export const ensureDragDropTouchLoaded = () => {
  if (typeof window === 'undefined') {
    return Promise.resolve();
  }

  if (window.DragDropTouch) {
    return Promise.resolve(window.DragDropTouch);
  }

  if (dragDropTouchLoadPromise) {
    return dragDropTouchLoadPromise;
  }

  const existingScript = document.querySelector(
    `script[src='${DRAG_DROP_TOUCH_SRC}']`
  );

  if (existingScript) {
    dragDropTouchLoadPromise = new Promise((resolve, reject) => {
      if (window.DragDropTouch) {
        resolve(window.DragDropTouch);
        return;
      }
      existingScript.addEventListener('load', () =>
        resolve(window.DragDropTouch || true)
      );
      existingScript.addEventListener('error', reject);
    });
    return dragDropTouchLoadPromise;
  }

  dragDropTouchLoadPromise = new Promise((resolve, reject) => {
    const script = document.createElement('script');
    script.src = DRAG_DROP_TOUCH_SRC;
    script.async = true;
    script.onload = () => resolve(window.DragDropTouch || true);
    script.onerror = (e) => reject(e);
    document.body.appendChild(script);
  });

  return dragDropTouchLoadPromise;
};
